/**
 * Tells whether presence status should be displayed.
 *
 * @returns {boolean}
 */
export function presenceStatusDisabled() {
    return Boolean(typeof interfaceConfig !== 'undefined' && (interfaceConfig === null || interfaceConfig === void 0 ? void 0 : interfaceConfig.DISABLE_PRESENCE_STATUS));
}
